import React, { useContext, useEffect } from "react"
import Spinner from "../components/elements/Spinner"
import Sogehts from "../components/home/Sogehts"
import Info from "../components/Info"
import MobileMenu from "../components/MobileMenu"
import TextBook, { TextBookKeys } from "../components/Textbook"
import { Context } from "../store/store"
const PromoSoon: React.FC = () => {
	const { globalState } = useContext(Context)

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			{globalState.strapi.homepage ? (
				<>
					<div className="relative gradientYellow">
						<picture>
							<source srcSet={process.env.PUBLIC_URL + "/images/promosoonDesktop.jpg"} media="(min-width: 768px)" />
							<img src={process.env.PUBLIC_URL + "/images/promosoonMobile.jpg"} alt="TREK Cashback-Aktion – Bald verfügbar" className="relative z-20 w-full  " />
						</picture>

						<Sogehts />

						{/* <Divider /> */}
					</div>
					<MobileMenu />
					<Info />
				</>
			) : (
				<div className="py-20 text-center">
					<Spinner />
					<TextBook textKey={TextBookKeys.HOMEPAGE} />
				</div>
			)}
		</>
	)
}
export default PromoSoon
